<template>
  <div class="smaller-container-wrapper full-height">
    <MobialisFormWithValidation
      @onValidate="submit"
      novalidate
      v-av-analytics-form-submit="{ elementText: $t('message.common.continue') }"
    >
      <h2>{{ $t('message.eCommerceV2.addressFormHeading') }}</h2>
      <p v-if="!isFinanceFlow">{{ $t('message.eCommerceV2.addressFormMsg') }}</p>
      <div class="row form-row mt-3 mt-sm-4">
        <div class="col-sm-8">
          <mobialis-text-input-with-validation
            rules="required"
            :label="$t('message.credit.streetAddress')"
            v-model="streetAddress"
            vid="streetAddress"
            data-cy="streetAddress"
          ></mobialis-text-input-with-validation>
        </div>
        <div class="col-sm-4">
          <mobialis-text-input-with-validation
            :label="$t('message.credit.unit#')"
            v-model="unitNumber"
            vid="unitNumber"
            data-cy="unitNumber"
          ></mobialis-text-input-with-validation>
        </div>
      </div>
      <div class="row form-row">
        <div class="col-sm-6">
          <mobialis-text-input-with-validation
            rules="required"
            :label="$t('message.common.city')"
            v-model="city"
            vid="city"
            data-cy="city"
          ></mobialis-text-input-with-validation>
        </div>
        <div class="col-sm-6">
          <mobialis-selection-input-with-validation
            v-if="!getThisIsAmerica"
            rules="required"
            :label="$t('message.common.province')"
            v-model="province"
            vid="province"
            :placeHolder="$t('message.common.chooseProvince')"
            :options="provinces"
            data-cy="province"
          ></mobialis-selection-input-with-validation>
          <mobialis-selection-input-with-validation
            v-else
            rules="required"
            :label="$t('message.common.state')"
            v-model="state"
            vid="state"
            :placeHolder="$t('message.common.chooseState')"
            :options="states"
            data-cy="state"
          ></mobialis-selection-input-with-validation>
        </div>
      </div>
      <mobialis-text-input-with-validation
        v-if="!getThisIsAmerica"
        class="input-width-100"
        rules="required|length:6"
        :label="$t('message.common.postalCode')"
        v-model="postalCode"
        vid="postalCode"
        mask-type="postalCode"
        data-cy="postalCode"
      ></mobialis-text-input-with-validation>
      <mobialis-text-input-with-validation
        v-else
        class="input-width-100"
        rules="required|length:5"
        :label="$t('message.common.zipCode')"
        v-model="zipCode"
        vid="zipCode"
        mask-type="zipCode"
        data-cy="zipCode"
      ></mobialis-text-input-with-validation>
      <InfoCard v-if="!isFinanceFlow" class="font-weight-bold text-center mt-5">
        <img class="mr-2 mb-1" :src="require('@/assets/shield-check-blue.svg')" alt="" width="16px" height="16px" />
        {{ $t('message.eCommerceV2.notAffectCredit') }}
      </InfoCard>
      <div class="push-down-desktop">
        <mobialis-button type="submit" class="mt-5 mb-3" data-cy="continue">{{
          $t('message.common.continue')
        }}</mobialis-button>
      </div>
    </MobialisFormWithValidation>
  </div>
</template>

<script>
import cloneDeep from 'lodash/fp/cloneDeep';
import { mapGetters } from 'vuex';
import { provinceMixin, stateMixin } from '@/mixins';
import InfoCard from '@/components/InfoCard.vue';

export default {
  name: 'AddressForm',
  mixins: [provinceMixin, stateMixin],
  components: {
    InfoCard,
  },
  data() {
    return {
      streetAddress: cloneDeep(this.$store.state.user.streetAddress),
      unitNumber: cloneDeep(this.$store.state.user.unit),
      city: cloneDeep(this.$store.state.user.city),
      province: cloneDeep(this.$store.state.user.province),
      postalCode: cloneDeep(this.$store.state.user.postalCode),
      state: cloneDeep(this.$store.state.user.state),
      zipCode: cloneDeep(this.$store.state.user.zipCode),
    };
  },
  computed: {
    ...mapGetters('business', ['getThisIsAmerica']),
    isFinanceFlow() {
      return this.currentSubFlow === 'finance';
    },
  },
  methods: {
    submit(isValid) {
      if (!isValid) {
        return;
      }
      this.$store.commit('user/SET_STREET_ADDRESS', this.streetAddress);
      this.$store.commit('user/SET_UNIT', this.unitNumber);
      this.$store.commit('user/SET_CITY', this.city);
      if (!this.getThisIsAmerica) {
        this.$store.commit('user/SET_PROVINCE_CODE', this.getProvinceCode(this.province));
        this.$store.commit('user/SET_PROVINCE', this.province);
        this.$store.commit('user/SET_POSTAL_CODE', this.postalCode);
      } else {
        this.$store.commit('user/SET_STATE', this.state);
        this.$store.commit('user/SET_STATE_CODE', this.getStateCode(this.state));
        this.$store.commit('user/SET_ZIP_CODE', this.zipCode);
      }
      this.$router.push({ path: this.getNextRoutePath() });
    },
  },
};
</script>
